"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { createPortal } from "react-dom";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropLocation } from "@/components/waves/drops/Drop";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import MemesLeaderboardDropCard from "./MemesLeaderboardDropCard";
import MemesLeaderboardDropHeader from "./MemesLeaderboardDropHeader";
import MemesLeaderboardDropDescription from "./MemesLeaderboardDropDescription";
import MemesLeaderboardDropVoteSummary from "./MemesLeaderboardDropVoteSummary";
import MemesLeaderboardDropArtistInfo from "./MemesLeaderboardDropArtistInfo";
import MemeDropTraits from "./MemeDropTraits";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import WaveDropActionsOptions from "@/components/waves/drops/WaveDropActionsOptions";
import WaveDropActionsOpen from "@/components/waves/drops/WaveDropActionsOpen";
import { VotingModal, MobileVotingModal } from "@/components/voting";
import VotingModalButton from "@/components/voting/VotingModalButton";
import useIsMobileScreen from "@/hooks/isMobileScreen";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import useLongPressInteraction from "@/hooks/useLongPressInteraction";
import CommonDropdownItemsMobileWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsMobileWrapper";
import WaveDropMobileMenuDelete from "@/components/waves/drops/WaveDropMobileMenuDelete";
import WaveDropMobileMenuOpen from "@/components/waves/drops/WaveDropMobileMenuOpen";
interface MemesLeaderboardDropProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly location?: DropLocation;
}
export const MemesLeaderboardDrop: React.FC<MemesLeaderboardDropProps> = t0 => {
  const $ = _c(81);
  const {
    drop,
    onDropClick,
    location: t1
  } = t0;
  const location = t1 === undefined ? DropLocation.WAVE : t1;
  const isMobileScreen = useIsMobileScreen();
  const {
    canDelete
  } = useDropInteractionRules(drop);
  const [isVotingModalOpen, setIsVotingModalOpen] = useState(false);
  const {
    hasTouchScreen
  } = useDeviceInfo();
  let t2;
  if ($[0] !== hasTouchScreen) {
    t2 = {
      hasTouchScreen
    };
    $[0] = hasTouchScreen;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    isActive,
    setIsActive,
    touchHandlers
  } = useLongPressInteraction(t2);
  let t3;
  if ($[2] !== drop.metadata) {
    t3 = drop.metadata?.find(_temp)?.data_value ?? "Artwork Title";
    $[2] = drop.metadata;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const title = t3;
  let t4;
  if ($[4] !== drop.metadata) {
    t4 = drop.metadata?.find(_temp2)?.data_value ?? "This is an artwork submission for The Memes collection.";
    $[4] = drop.metadata;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const description = t4;
  let t5;
  if ($[6] !== drop.parts) {
    t5 = drop.parts.at(0)?.media.at(0);
    $[6] = drop.parts;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const artworkMedia = t5;
  let t6;
  if ($[8] !== drop.top_raters) {
    t6 = drop.top_raters?.slice(0, 3) ?? [];
    $[8] = drop.top_raters;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const firstThreeVoters = t6;
  let t7;
  if ($[10] !== drop || $[11] !== hasTouchScreen || $[12] !== onDropClick) {
    t7 = () => !hasTouchScreen && onDropClick(drop);
    $[10] = drop;
    $[11] = hasTouchScreen;
    $[12] = onDropClick;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== drop) {
    t8 = <MemesLeaderboardDropArtistInfo drop={drop} />;
    $[14] = drop;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== canDelete || $[17] !== drop || $[18] !== hasTouchScreen) {
    t9 = !hasTouchScreen && <><div className="tw-h-8"><WaveDropActionsOpen drop={drop} /></div><div className="tw-h-8">{canDelete && <WaveDropActionsOptions drop={drop} />}</div></>;
    $[16] = canDelete;
    $[17] = drop;
    $[18] = hasTouchScreen;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <div className="tw-flex tw-items-center">{t9}</div>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t8) {
    t11 = <div className="tw-flex tw-items-center tw-justify-between">{t8}{t10}</div>;
    $[22] = t10;
    $[23] = t8;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== title) {
    t12 = <MemesLeaderboardDropHeader title={title} />;
    $[25] = title;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== description) {
    t13 = <MemesLeaderboardDropDescription description={description} />;
    $[27] = description;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = <div className="tw-mt-1 sm:tw-mt-0 sm:tw-ml-[3.25rem]">{t12}{t13}</div>;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t11 || $[33] !== t14) {
    t15 = <div className="tw-p-4"><div className="tw-flex tw-flex-col tw-gap-y-1">{t11}{t14}</div></div>;
    $[32] = t11;
    $[33] = t14;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== artworkMedia || $[36] !== location) {
    t16 = artworkMedia && <div className={`tw-flex tw-justify-center tw-h-96 ${location === DropLocation.WAVE ? "tw-bg-iron-800/30" : "tw-bg-iron-900/40"}`}><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={true} /></div>;
    $[35] = artworkMedia;
    $[36] = location;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== drop) {
    t17 = <MemeDropTraits drop={drop} />;
    $[38] = drop;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] !== drop.context_profile_context || $[41] !== drop.raters_count || $[42] !== drop.rating || $[43] !== drop.rating_prediction || $[44] !== drop.wave.voting_credit_type || $[45] !== firstThreeVoters) {
    t18 = <div className="tw-px-6 @[700px]:tw-px-0"><MemesLeaderboardDropVoteSummary current={drop.rating} projected={drop.rating_prediction} creditType={drop.wave.voting_credit_type} ratersCount={drop.raters_count} topVoters={firstThreeVoters} userContext={drop.context_profile_context} /></div>;
    $[40] = drop.context_profile_context;
    $[41] = drop.raters_count;
    $[42] = drop.rating;
    $[43] = drop.rating_prediction;
    $[44] = drop.wave.voting_credit_type;
    $[45] = firstThreeVoters;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setIsVotingModalOpen(true);
    $[47] = t19;
  } else {
    t19 = $[47];
  }
  let t20;
  if ($[48] !== drop) {
    t20 = <div className="tw-pt-4 tw-pb-4 tw-px-6 tw-flex tw-justify-center @[700px]:tw-pt-0 @[700px]:tw-pb-0 @[700px]:tw-px-0 tw-w-full @[700px]:tw-w-auto tw-border-t tw-border-solid tw-border-iron-800 @[700px]:tw-border-none tw-border-x-0 tw-border-b-0" onClick={_temp3}><VotingModalButton drop={drop} onClick={t19} /></div>;
    $[48] = drop;
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t18 || $[51] !== t20) {
    t21 = <div className="tw-mt-4 lg:tw-mt-0 tw-flex tw-flex-col tw-gap-y-2 @[700px]:tw-flex-row tw-justify-between @[700px]:tw-pb-4 @[700px]:tw-px-4 @[700px]:tw-items-center">{t18}{t20}</div>;
    $[50] = t18;
    $[51] = t20;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t15 || $[54] !== t16 || $[55] !== t17 || $[56] !== t21) {
    t22 = <div>{t15}{t16}{t17}{t21}</div>;
    $[53] = t15;
    $[54] = t16;
    $[55] = t17;
    $[56] = t21;
    $[57] = t22;
  } else {
    t22 = $[57];
  }
  let t23;
  if ($[58] !== drop || $[59] !== isMobileScreen || $[60] !== isVotingModalOpen) {
    t23 = isMobileScreen ? <MobileVotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} /> : <VotingModal drop={drop} isOpen={isVotingModalOpen} onClose={() => setIsVotingModalOpen(false)} />;
    $[58] = drop;
    $[59] = isMobileScreen;
    $[60] = isVotingModalOpen;
    $[61] = t23;
  } else {
    t23 = $[61];
  }
  let t24;
  if ($[62] !== drop || $[63] !== t22 || $[64] !== t23) {
    t24 = <MemesLeaderboardDropCard drop={drop}>{t22}{t23}</MemesLeaderboardDropCard>;
    $[62] = drop;
    $[63] = t22;
    $[64] = t23;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  let t25;
  if ($[66] !== t24 || $[67] !== touchHandlers) {
    t25 = <div {...touchHandlers}>{t24}</div>;
    $[66] = t24;
    $[67] = touchHandlers;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  let t26;
  if ($[69] !== canDelete || $[70] !== drop || $[71] !== hasTouchScreen || $[72] !== isActive || $[73] !== setIsActive) {
    t26 = hasTouchScreen && createPortal(<CommonDropdownItemsMobileWrapper isOpen={isActive} setOpen={setIsActive}><div className="tw-grid tw-grid-cols-1 tw-gap-y-2"><WaveDropMobileMenuOpen drop={drop} onOpenChange={() => setIsActive(false)} />{canDelete && <WaveDropMobileMenuDelete drop={drop} onDropDeleted={() => setIsActive(false)} />}</div></CommonDropdownItemsMobileWrapper>, document.body);
    $[69] = canDelete;
    $[70] = drop;
    $[71] = hasTouchScreen;
    $[72] = isActive;
    $[73] = setIsActive;
    $[74] = t26;
  } else {
    t26 = $[74];
  }
  let t27;
  if ($[75] !== t25 || $[76] !== t26) {
    t27 = <div className="tw-w-full tw-group">{t25}{t26}</div>;
    $[75] = t25;
    $[76] = t26;
    $[77] = t27;
  } else {
    t27 = $[77];
  }
  let t28;
  if ($[78] !== t27 || $[79] !== t7) {
    t28 = <div className="tw-w-full tw-cursor-pointer tw-@container" onClick={t7}>{t27}</div>;
    $[78] = t27;
    $[79] = t7;
    $[80] = t28;
  } else {
    t28 = $[80];
  }
  return t28;
};
function _temp(m) {
  return m.data_key === "title";
}
function _temp2(m_0) {
  return m_0.data_key === "description";
}
function _temp3(e) {
  return e.stopPropagation();
}